import axios from "axios";

const setAxiosHeader = (token) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (token) {
    // Apply to every request
    // axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.defaults.headers.token = token;
    axios.defaults.headers.timeZone = timeZone;

  } else {

    // Delete auth header
    delete axios.defaults.headers.token;
  }
};

export const setChargingStationID = (ev_charging_site_id) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (ev_charging_site_id) {
    // Apply to every request
    // axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.defaults.headers.selected_ev_charging_site_id = ev_charging_site_id;
    axios.defaults.headers.timeZone = timeZone;

  } else {
    // Delete auth header
    delete axios.defaults.headers.selected_ev_charging_site_id;
  }
};

export default setAxiosHeader;
